import { ApexUIProvider, theme } from '@apexinternal/ui-components'
import { ChakraProvider } from '@chakra-ui/react'
import { OktaAuth } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'semantic-ui-less/semantic.less'
import { startRum } from 'utils/datadog'
import { OKTA_CONFIG } from './constants'
import { App } from './containers/App'
import { AuthProvider } from './containers/contexts/auth/AuthContext'
import { PermissionsProvider } from './containers/contexts/permissions/PermissionsContext'
import { SearchProvider } from './containers/providers'
import './index.less'
import * as serviceWorker from './serviceWorker'
import configureStore from './store'
import { RoutesEnum } from './types/RoutesEnum'
import { loadIntlMessages } from './utils'

startRum()

const store = configureStore()
const oktaAuth = new OktaAuth(OKTA_CONFIG)
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Security oktaAuth={oktaAuth}>
        <IntlProvider {...loadIntlMessages()}>
          <AuthProvider>
            <PermissionsProvider>
              <BrowserRouter basename={RoutesEnum.Root}>
                <ChakraProvider theme={theme}>
                  <ApexUIProvider>
                    <SearchProvider>
                      <App />
                    </SearchProvider>
                  </ApexUIProvider>
                </ChakraProvider>
              </BrowserRouter>
            </PermissionsProvider>
          </AuthProvider>
        </IntlProvider>
      </Security>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
